import React, { useState } from "react";
import ReactDOM from 'react-dom';
import "./addPlayerModal.scss";
import { useMutation, useSubscription } from "@apollo/client";
import { ADD_PLAYER_MUTATION } from "../api/queries";

const AddPlayerModal = ({isShowing, hide}) => {
    const createPlayerCompleted = () => {
        hide();
    }   

    const [createPlayer, {addData, addLoading, addError }] = useMutation(ADD_PLAYER_MUTATION, {
        onCompleted: createPlayerCompleted
    });
    const [playerName, setPlayerName] = useState('');

    if (!isShowing) return null;

    const addPlayer = () => {
        if (playerName) {
            createPlayer({
                variables: {
                    player: {
                        name: playerName
                    }
                }
            });
        }
    }

    return ReactDOM.createPortal(
        <React.Fragment>
        <div className="modal-overlay"/>
        <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div className="modal">
            <div className="modal-header">
              <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div>
                <h3>Add A Player</h3>
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" value={playerName} onInput={e => setPlayerName(e.target.value)}/>
                <button onClick={addPlayer}>Add Player</button>
            </div>
          </div>
        </div>
      </React.Fragment>, document.body
    )
};

export default AddPlayerModal;